import { preferenceActionTypes } from '../actions/preferenceActions.js';

const initState = {
  lunchArrivalSmsDisabled: true,
  lunchArrivalEmailDisabled: true,
  lunchArrivalPushNotificationDisabled: true,
  marketingEmailDisabled: true,
  shuttleReminderEmailDisabled: true,
  error: null,
  loading: false,
  loaded: false,
};

/**
 *
 * @param {PreferenceState.State} state
 * @param {Object} action
 */
const PreferenceReducer = (state = initState, action) => {
  const {
    lunchArrivalSmsDisabled,
    lunchArrivalPushNotificationDisabled,
    lunchArrivalEmailDisabled,
    marketingEmailDisabled,
    shuttleReminderEmailDisabled,
  } = action;

  switch (action.type) {
    case preferenceActionTypes.getNotificationsStart:
      return {
        ...state,
        ...{
          loading: true,
          loaded: false,
        },
      };

    case preferenceActionTypes.getNotificationsSuccess:
      return {
        ...state,
        ...{
          lunchArrivalSmsDisabled,
          lunchArrivalPushNotificationDisabled,
          lunchArrivalEmailDisabled,
          marketingEmailDisabled,
          shuttleReminderEmailDisabled,
          loading: false,
          loaded: true,
          error: null,
        },
      };

    case preferenceActionTypes.changeNotificationsSuccess:
      return {
        ...state,
        ...{
          lunchArrivalSmsDisabled,
          lunchArrivalPushNotificationDisabled,
          lunchArrivalEmailDisabled,
          marketingEmailDisabled,
          shuttleReminderEmailDisabled,
          loading: false,
          loaded: true,
          error: null,
        },
      };

    default:
      return state;
  }
};

export default PreferenceReducer;
